webpackJsonp([92],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(30)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(40),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(32)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(35),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(36)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(39),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(28);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(45);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sensors = window.sensorsDataAnalytic201505;
var is_production = "production" === 'production';
console.log(is_production, '###############');
var options = {
  // server_url: is_production?'https://datasink.thebeastshop.com/sa?project=production':'https://datasink.thebeastshop.com/sa?project=default',
  // server_url: 'https://datasink.thebeastshop.com/sa?project=default',
  server_url: 'https://datasink.thebeastshop.com/sa?project=production',
  platform_type: 'WAP'
};

var Sa = function () {
  function Sa(_ref) {
    var _ref$server_url = _ref.server_url,
        server_url = _ref$server_url === undefined ? '' : _ref$server_url,
        _ref$platform_type = _ref.platform_type,
        platform_type = _ref$platform_type === undefined ? '' : _ref$platform_type;
    (0, _classCallCheck3.default)(this, Sa);

    this.isSDKinit = false;
    this.server_url = server_url;

    // 公共属性
    this.is_login = false;
    this.vip_level = '';
    this.current_page_type = '';
    this.current_page_name = '';
    this.current_page_id = '';
    this.platform_type = platform_type;
    this.thelatest_utm_source = '';

    // 前向页面名称
    this.refer_page_name = '';
    this.refer_page_type = '';
    this.refer_page_id = '';
  }

  (0, _createClass3.default)(Sa, [{
    key: 'setParams',
    value: function setParams() {
      if (this.isSDKinit) return;

      this._setParam();
      this._registerApp();
    }
  }, {
    key: 'changeIdentify',
    value: function changeIdentify(distinctID) {
      sensors.identify(distinctID, true);
    }
  }, {
    key: 'track',
    value: function track() {
      return sensors.track.apply(sensors, arguments);
    }
  }, {
    key: 'addCart',
    value: function addCart(options) {
      var params = (0, _extends3.default)({}, this.getReferPageName(), options);

      this.track('AddToShoppingCart', params);
    }
  }, {
    key: 'registerButtonClick',
    value: function registerButtonClick(name) {
      this.track('RegisterButtonClick', {
        button_name: name
      });
    }
  }, {
    key: 'getUTMProp',
    value: function getUTMProp() {
      var _sensors$getPresetPro = sensors.getPresetProperties(),
          $latest_utm_campaign = _sensors$getPresetPro.$latest_utm_campaign,
          $latest_utm_content = _sensors$getPresetPro.$latest_utm_content,
          $latest_utm_source = _sensors$getPresetPro.$latest_utm_source,
          $latest_utm_term = _sensors$getPresetPro.$latest_utm_term;

      return {
        theLatestUtmCampaign: $latest_utm_campaign,
        theLatestUtmContent: $latest_utm_content,
        theLatestUtmSource: $latest_utm_source,
        theLatestUtmTerm: $latest_utm_term
      };
    }
  }, {
    key: 'sharePage',
    value: function sharePage(type, options) {
      var params = (0, _extends3.default)({}, this.getReferPageName());

      this.track('ShareClick', (0, _extends3.default)({
        share_type: type
      }, params, options));
    }
  }, {
    key: 'shareSave',
    value: function shareSave() {
      var params = (0, _extends3.default)({}, this.getReferPageName());

      this.track('MPShareSave', (0, _extends3.default)({}, params));
    }
  }, {
    key: 'editCart',
    value: function editCart(type) {
      this.track('EditShoppingCart', {
        shopping_cart_edit_type: type
      });
    }
  }, {
    key: 'buyNow',
    value: function buyNow(options) {
      var params = (0, _extends3.default)({}, this.getReferPageName(), options);

      this.track('buyNow', options);
    }
  }, {
    key: 'addIndex',
    value: function addIndex(index, num) {
      return index + num;
    }
  }, {
    key: 'setOpenid',
    value: function setOpenid(openId) {
      return sensors.setOpenid(openId);
    }
  }, {
    key: 'login',
    value: function login(id) {
      this.is_login = true;

      return sensors.login(id);
    }
  }, {
    key: 'setCurrentPageWithOutRefer',
    value: function setCurrentPageWithOutRefer(type, name, id, options) {
      // this.refer_page_name = this.current_page_name
      // this.refer_page_type = this.current_page_type
      // this.refer_page_id = this.current_page_id

      this.current_page_type = type || '';
      this.current_page_name = name || '';
      this.current_page_id = id || '';

      this.setReferPageNameByCache({
        current_page_name: name || '',
        current_page_id: id || '',
        current_page_type: type || ''
      });

      return (0, _extends3.default)({}, options);
    }

    // 设置每个页面的公共属性

  }, {
    key: 'setCurrentPage',
    value: function setCurrentPage(type, name, id, options) {
      // this.refer_page_name = this.current_page_name
      // this.refer_page_type = this.current_page_type
      // this.refer_page_id = this.current_page_id
      var referData = this.getReferPageNameByCache();

      if (referData) {
        this.refer_page_name = referData.current_page_name;
        this.refer_page_type = referData.current_page_type;
        this.refer_page_id = referData.current_page_id;
      }

      this.current_page_type = type || '';
      this.current_page_name = name || '';
      this.current_page_id = id || '';

      this.setReferPageNameByCache({
        current_page_name: name || '',
        current_page_id: id || '',
        current_page_type: type || ''
      });

      return (0, _extends3.default)({}, options);
    }

    // 获取前向页面名称

  }, {
    key: 'getReferPageName',
    value: function getReferPageName() {
      return {
        refer_page_name: this.refer_page_name,
        refer_page_id: this.refer_page_id,
        refer_page_type: this.refer_page_type
      };
    }
  }, {
    key: 'getReferPageNameByCache',
    value: function getReferPageNameByCache() {
      return JSON.parse(window.sessionStorage.getItem('_sa_refer')) || null;
    }
  }, {
    key: 'setReferPageNameByCache',
    value: function setReferPageNameByCache(data) {
      window.sessionStorage.setItem('_sa_refer', (0, _stringify2.default)(data));
    }
  }, {
    key: 'getActivity',
    value: function getActivity(labels) {
      var activity = [];
      labels.forEach(function (label) {
        activity.push(label.type);
      });

      return activity;
    }
  }, {
    key: 'getProp',
    value: function getProp() {
      return sensors.getPresetProperties();
    }
  }, {
    key: 'getAnonymousID',
    value: function getAnonymousID() {
      return sensors.quick('getAnonymousID');
    }
  }, {
    key: 'clickNavBar',
    value: function clickNavBar(name) {
      return this.track('NavigationBar', {
        button_name: name
      });
    }
  }, {
    key: 'clickPerson',
    value: function clickPerson(name) {
      return this.track('PersonalCenter', {
        button_name: name
      });
    }
  }, {
    key: '_autoQuick',
    value: function _autoQuick() {
      return sensors.quick('autoTrack');
    }
  }, {
    key: 'init',
    value: function init() {
      this._registerPage();
      // this._autoQuick()

      sensors.init({
        server_url: this.server_url,
        heatmap: {
          // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
          // 默认只有点击 a input button textarea 四种元素时，才会触发 $WebClick 元素点击事件
          clickmap: 'default'
        },
        show_log: true,
        use_client_time: true,
        app_js_bridge: true,
        send_type: 'beacon'
      });
    }
  }, {
    key: '_registerPage',
    value: function _registerPage() {
      var _this = this;

      sensors.registerPage({
        platform_type: this.platform_type,

        is_login: function is_login() {
          return _this.is_login;
        },

        vip_level: function vip_level() {
          return _this.vip_level;
        },

        current_page_type: function current_page_type() {
          return _this.current_page_type;
        },

        current_page_name: function current_page_name() {
          return _this.current_page_name;
        },

        current_page_id: function current_page_id() {
          return _this.current_page_id;
        },

        thelatest_utm_source: function thelatest_utm_source() {
          return _this.thelatest_utm_source;
        }
      });
    }
  }]);
  return Sa;
}();

module.exports = new Sa(options);

function loop() {}

/***/ }),

/***/ 1910:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _page = __webpack_require__(51);

var _index = __webpack_require__(1911);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _page.Page)('rule', {
  el: '#app',
  template: '<rule />',
  components: {
    rule: _index2.default
  }
});

/***/ }),

/***/ 1911:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1912)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1913),
  /* template */
  __webpack_require__(1915),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1912:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bridge = __webpack_require__(7);

var _bridge2 = _interopRequireDefault(_bridge);

var _data = __webpack_require__(1914);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "rule",

  data: function data() {
    return {
      dataLoaded: false,
      data: _data2.default
    };
  },


  components: {},

  created: function created() {
    this.$hideLoading();
    this.$setTitle("THE BEAST 野兽派个人信息保护政策");
  },


  methods: {}
};

/***/ }),

/***/ 1914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(86);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ruleData = {
  desc1: ["本版本最近更新日期：2022年02月。"],
  desc2: ["请用户在使用本公司的产品或服务前，仔细阅读并了解本《个人信息保护政策》。", "如果用户有任何疑问、意见或建议，请通过以下联系方式与本公司联系：", "上海野派电子商务有限公司（“野兽派”APP运营方）", "注册地址：上海市虹口区欧阳路196号10号楼9层20室", "电子邮件： service@thebeastshop.com", "电 话：400-9200-108"],
  stress: {
    title: "本政策将帮助用户了解以下内容：",
    items: ["一、如何收集和使用用户的个人信息", "二、如何使用Cookie和同类技术", "三、网站信标和像素标签", "四、个人信息的管理与保护", "五、如何共享、转让、公开披露用户的个人信息", "六、个人信息的跨境传输", "七、用户权限", "八、如何处理未成年人的个人信息", "九、当用户向本公司提供第三方数据", "十、本政策如何更新", "十一、如何联系本公司"]
  },
  desc3: ["野兽派（以下称“本公司”）深知个人信息对用户的重要性，并会尽全力保护用户的个人信息安全可靠。本公司致力于维持用户对本公司的信任，恪守以下原则，保护用户的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，本公司承诺，本公司将按业界成熟的安全标准，采取相应的安全保护措施来保护用户的个人信息。"],
  contents: [{
    title: "一、如何收集和使用用户的个人信息",
    items: [{
      itemTitle: "1.个人信息的定义",
      itemList: [{
        listTitle: "“个人信息”即“公民个人信息”，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 "
      }]
    }, {
      itemTitle: "2.本公司收集的个人信息",
      itemList: [{
        listTitle: "在用户访问野兽派旗下门店、网站（包括野兽派官方网站、野兽派各平台旗舰店）、社交媒体平台（包括野兽派旗下微信公众号、野兽派旗下微博官方账号，以及其他本公司使用的、为用户提供各类服务的社交媒体平台）、手机应用程序野兽派APP（以下可简称“APP”）、野兽派微信小程序时，本公司可能会收集用户的个人信息，包括："
      }, {
        listTitle: "（1）本公司提供的下述业务功能需要依赖部分信息才得以运行：",
        listItems: ["· 用户注册本公司的会员时：为验证用户身份、识别用户，需要收集用户的姓名、性别、联络方式（手机号码、电子邮件，或由用户提供的其他联络信息）、微信账号、微博账号、QQ账号、邮箱账号或用户同意提供的其他第三方平台账号相关信息。如果用户不提供上述部分或全部信息，可能会无法注册为本公司的会员。", "· 用户购买本公司非跨境类商品或使用本公司提供的非跨境类服务时：为了完成订单支付及完成后续配送服务，本公司可能会收集用户的姓名、联系方式（电话号码或由用户提供的其他联络信息）、配送地址、用户的第三方平台账号信息、用户的支付方式（支付宝、微信）相关信息。如果用户不提供这些信息，可能会无法成功购买本公司商品或使用本公司提供的服务。", "· 用户购买本公司跨境类商品或使用本公司提供的跨境类服务时：除上述购买非跨境类商品或使用非跨境类服务需要提供的信息外，用户另需提供实名认证的个人信息（真实姓名、用户身份证号）。如果用户不提供上述信息，会导致无法购买本公司跨境类商品或无法使用本公司提供的跨境类服务。", "· 用户分享APP页面至微信客户端/从APP链接至微信小程序时：本公司可能会收集用户的手机软件安装列表，用以实现分享和跳转功能。如果用户不提供上述信息，可能会导致无法分享APP页面至微信客户端/无法通过APP链接跳转至微信小程序。"]
      }, {
        listTitle: "（2）用户可自主选择向本公司提供或允许本公司收集下列信息：",
        listItems: ["· 用户参加本公司举办的各类促销/体验活动时：本公司可能会收集用户的姓名、性别、出生日期、具体住址、联系方式（手机号码、微信账号，或由用户提供的其他联络信息）、照片、第三方平台账号相关信息。届时本公司将针对特定促销/体验活动另行取得用户授权同意。如果用户不提供上述信息，可能会导致无法参加促销/体验活动或获得相应的礼品或活动限定折扣。", "举例：本公司将于注册为会员的用户每年生日期间于本公司线上或线下渠道（具体视本公司会员政策及每年活动公告而定）向该用户提供免费生日礼一份，如用户拒绝向本公司提供生日信息，则无法获得前述会员生日礼。", "· 本公司提供账号验证或营销信息推送服务时：本公司可能会预先收集用户的联系方式（手机号码、微信账号），用来提供账号验证服务，或营销信息推送服务。如果用户不提供上述信息，可能会导致无法获得与前述联系方式绑定的账号验证，或会导致无法通过前述联系方式获得本公司提供的免费营销信息推送服务。"]
      }, {
        listTitle: "（3）在用户使用下述业务功能时，本公司的App会向用户申请下列与个人信息相关的系统权限：",
        listItems: ["· 用户进行订单评价时：如用户申请对已完成订单进行拍照附图或相册传图的方式评价以获取积分，则本公司的App会向用户申请用户移动设备的摄像头及/或相册系统权限（以用户评价时的自主选择为依据发出权限许可请求），如果用户不主动进行系统权限授权，将会导致本公司无法提供评价的业务功能。", "· 用户进行订单评价时：如用户申请对已完成订单进行拍照附图或相册传图的方式评价以获取积分，则本公司的App会向用户申请用户移动设备的摄像头及/或相册系统权限（以用户评价时的自主选择为依据发出权限许可请求），如果用户不主动进行系统权限授权，将会导致本公司无法提供评价的业务功能。", "· 用户查找最近门店时：如用户申请查找本公司距离最近的门店，则本公司的APP会向用户申请移动设备的定位信息。如果用户不主动进行系统权限授权，将会导致本公司无法提供该项服务。", "· 用户使用语音祝福卡功能时：如用户申请使用语音祝福卡功能，则本公司的APP会向用户申请移动设备的麦克风授权。如果用户不主动进行系统权限授权，将会导致本公司无法提供该项服务。", "除上述系统权限之外，用户可自主选择是否额外授予App其他的系统权限。"]
      }, {
        listTitle: "（4）除上述个人信息之外，在此后的业务发展进程中，App可能会基于改善服务质量、研发新产品或服务的目的向用户收集其他个人信息，届时。用户可自主选择是否额外提供App其他的个人信息。这些信息并非该业务功能运行所必需，本公司不会强制要求用户提供这些信息，用户如拒绝提供不会对使用核心业务功能（浏览App、通过App下单本公的商品等服务）产生不利影响，具体后果及影响本公司将于收集个人信息时同步告知。"
      }]
    }, {
      itemTitle: "3.从第三方收集个人信息",
      itemList: [{
        listTitle: "本公司可能从第三方收集用户的个人信息。比如，用户通过第三方平台购买本公司的商品或服务，为完成订单，本公司将会从第三方平台收集所需的用户个人信息；本公司通过第三方（包括向本公司提供软件开发、技术支持、数据分析、活动统筹或管理业务的主体）向用户提供服务的，本公司将从该第三方收集用户同意提供的个人信息。目前可收集用户信息的第三方平台及收集目的："
      }, {
        listTitle: "(1)微信平台（主动授权），用于第三方登录；"
      }, {
        listTitle: "(2)QQ平台（主动授权），用于第三方登录；"
      }, {
        listTitle: "(3)微博平台（主动授权），用于第三方登录。"
      }]
    }, {
      itemTitle: "4.个人信息的使用",
      itemList: [{
        listTitle: "本公司对于收集得来的用户个人信息，将用于以下目的："
      }, {
        listTitle: "（1）为用户提供本公司旗下品牌商品和相关服务；"
      }, {
        listTitle: "（2）为用户提供本公司旗下品牌商品和服务的相关信息；"
      }, {
        listTitle: "（3）为提升本公司的商品及服务质量；"
      }, {
        listTitle: "（4）为其他相关法律允许的正当目的。"
      }, {
        listTitle: "此外，在使用用户个人信息时有必要超出本政策既定的使用目的或范围的，本公司将另行取得用户的明示同意。"
      }]
    }]
  }, {
    title: "二、如何使用Cookie和同类技术",
    stress: "Cookie",
    items: [{
      itemTitle: "",
      itemList: [{
        listTitle: "为确保网站或APP正常运转，本公司会在用户的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站或APP能够存储用户的偏好或购物车内的商品相关数据。 Cookie具体作用如下："
      }, {
        listTitle: "（1）用于保持用户的登录状态；"
      }, {
        listTitle: "（2）用于app读取登录用户的基本信息（会员号，姓名，积分等）；"
      }, {
        listTitle: "（3） 用户打开app的时长（AOS广告投放监测）；"
      }, {
        listTitle: "（4）页面访问路径，用于改善app使用体验（包括页面浏览路径、按钮点击行为、用户收藏下单等行为）。",
        listItems: ["本公司不会将 Cookie 用于本政策所述目的之外的任何用途。用户可根据自己的偏好及相应浏览器自主管理或删除 Cookie，删除方式如下：", "· <internet Explorer>浏览器", "删除链接：https://support.microsoft.com/zh-cn/help/17442/windows-internet-explorer-delete-manage-cookies", "· <google Chrome>浏览器", "删除链接：https://support.google.com/chrome/answer/95647", "· <safari>浏览器 删除链接：", "https://support.apple.com/kb/PH19214?locale=zh_CN", "· <mozilla Firefox>浏览器 ", "删除链接：https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies", "用户可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果用户这么做，则需要在每一次访问本公司的网站时亲自更改用户设置。 ", "另外，本公司的Cookie也设有自动清理缓存机制，目前本公司保存Cookie的期间为六个月，自Cookie生成之日起六个月后将自动清理失效。"]
      }]
    }]
  }, {
    title: "三、网站信标和像素标签",
    items: [{
      itemTitle: "",
      itemList: [{
        listTitle: "除 Cookie 外，为了更好地提供服务，本公司还会在网站或APP上使用网站信标和像素标签或其他同类技术。举例来说，本公司向用户发送的电子邮件可能含有链接至本公司相关网站内容的URL链接，如果用户点击该链接，本公司则会跟踪此次点击，帮助本公司了解用户的商品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，本公司能够获知电子邮件是否被打开。如果用户不希望自己的活动以这种方式被追踪，则可以随时从本公司的寄信名单中退订。"
      }]
    }]
  }, {
    title: "四、个人信息的管理与保护",
    items: [{
      itemTitle: "1. 本公司将严格遵守中华人民共和国的有关法律、法规的规定，采取必要而适当的安全技术措施，使用符合业界标准的安全防护措施保护用户提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。本公司会采取一切合理可行的措施，保护用户的个人信息。例如：",
      itemList: [{
        listTitle: "（1）本公司会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止用户的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。"
      }, {
        listTitle: "（2）本公司的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。"
      }, {
        listTitle: "（3）本公司采取加密技术对用户个人信息进行加密保存，包括SHA256，MD5等技术，并通过隔离技术进行隔离。"
      }, {
        listTitle: "（4）本公司采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。"
      }]
    }, {
      itemTitle: "2. 就用户向本公司提供的个人信息，除本政策“第六条个人信息的跨境传输”约定的内容外，本公司将个人信息保存于中国境内。就上述数据的保存期限、处理方式等，本公司也将严格按照相关法律、法规的规定执行。如无法律允许的特殊情况，本公司通常会将该等数据保存至用户注销账户。"
    }, {
      itemTitle: "3. 本公司会采取一切合理可行的措施，确保未收集无关的个人信息。本公司只会在达成本政策所述目的所需的期限内保留用户的个人信息，除非需要延长保留期或受到法律的允许。"
    }, {
      itemTitle: "4. 本公司将根据需要，不定期更新并公开安全风险、个人信息安全影响评估等报告的有关内容。"
    }, {
      itemTitle: "5. 互联网环境并非百分之百安全，本公司将尽力确保或担保用户发送给本公司的任何信息的安全性。如果本公司的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致用户的合法权益受损，本公司将承担相应的法律责任。"
    }, {
      itemTitle: "6. 在不幸发生个人信息安全事件后，本公司将按照法律法规的要求，及时向用户告知：安全事件的基本情况和可能的影响、本公司已采取或将要采取的处置措施、用户可自主防范和降低风险的建议、对用户的补救措施等。本公司将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知用户，难以逐一告知个人信息主体时，本公司会采取合理、有效的方式发布公告。 同时，本公司还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 "
    }]
  }, {
    title: "五、如何委托处理、共享、转让、公开披露用户的个人信息",
    items: [{
      itemTitle: "1. 委托处理 ",
      itemList: [{
        listTitle: "本业务功能中某些具体的模块或功能须由外部供应商提供协助。例如本公司会聘请服务提供商来协助本公司提供客户支持、聘请服务提供商来协助本公司进行用户个人真实信息的核实（仅适用于用户购买跨境商品的情形）。",
        listItems: ["对本公司委托处理个人信息的公司、组织和个人，其应有提供相应服务的完整资质，且本公司会与其签署严格的保密协定或于相关服务合同中嵌入保密条款，并要求他们按照本公司的要求、本政策以及其他任何相关的保密和安全法律法规及安全措施来处理个人信息。"]
      }]
    }, {
      itemTitle: "2. 共享",
      itemList: [{
        listTitle: "通常情况下，本公司不会与本公司以外的任何公司、组织和个人分享用户的个人信息，除非获得用户的明确同意。目前，本公司会在以下情形中，向用户征求用户对共享个人信息的授权同意："
      }, {
        listTitle: "（1）为了业务的管理以及提升服务水平，本公司可能会与本公司的关联公司（包括本公司的母公司、本公司的母公司直接或间接持股50%以上的公司，以下亦同）共享用户提供的所有个人信息。"
      }, {
        listTitle: "（2）为了完成用户与本公司发生的商品或服务交易、为用户提供完善的售后服务、信息服务以及其他相关服务、提升用户的服务使用体验，本公司可能会在必要的限度内向本公司的供应商（包括物流公司、支付平台、通知推送平台、向本公司提供软件开发、技术支持、数据分析、活动统筹或管理业务的主体）提供与上述服务有关的用户的个人信息。例如，本公司会向物流公司共享用户提供的收件人姓名、收件地址及联系电话信息，向支付平台共享用户的交易单号及交易金额信息。"
      }, {
        listTitle: "（3）为了完成用户与本公司发生的商品或服务交易、为用户提供完善的售后服务、信息服务以及其他相关服务、提升用户的服务使用体验，本公司可能会在必要的限度内向我们的供应商（包括物流公司、支付平台、售后客服平台、通知推送平台、向本公司提供软件开发、技术支持、数据分析、活动统筹或管理业务的主体）提供与服务有关的用户的个人信息。本公司产品嵌入第三方供应商代码、接口、插件等的情形包括："
      }, {
        listTable: "用html填充"
      }, {
        listTitle: "本公司可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享用户的个人信息。"
      }]
    }, {
      itemTitle: "3. 转让",
      itemList: [{
        listTitle: "本公司不会将用户的个人信息转让给任何公司、组织和个人，但以下情形除外：",
        listItems: ["a) 在获取明确同意的情况下转让：获得用户的明确同意后，本公司会向其他方转让用户的个人信息；", "b) 在涉及合并、收购或破产清算时，如涉及到个人信息转让，本公司会在要求新的持有用户个人信息的公司、组织继续受此个人信息保护政策的约束，否则本公司将要求该公司、组织重新向用户征求授权同意。"]
      }]
    }, {
      itemTitle: "4. 公开披露",
      itemList: [{
        listTitle: "本公司仅会在以下情形下，公开披露用户的个人信息： ",
        listItems: ["a) 获得用户明确同意后； ", "b) 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，本公司可能会公开披露用户的个人信息。"]
      }]
    }]
  }, {
    title: "六、个人信息的跨境传输",
    items: [{
      itemList: [{
        listTitle: "原则上，本公司在中华人民共和国大陆地区内收集和产生的个人信息，并将该等个人信息存储在中华人民共和国大陆地区内。",
        listItems: ["为了提升本公司品牌对用户的服务质量提供跨境海淘等服务项目，本公司可能会将用户提供的所有个人信息提供给本公司的境外的关联公司或跨境电子商务中的合作公司，这意味着，在获得用户的授权同意后，用户的个人信息可能会被转移到用户使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。（目前接受个人信息跨境传输的主体公司THEBEASTSHOP HK LIMITED，如有新增主体，本公司将实时更新个人信息保护政策，并获得用户的明示同意。具体跨境电子商务政策请点击：《野兽派海外产品购物协议》https://www.thebeastshop.com/static/oversea-qa）", "在进行上述个人信息跨境传输的过程中，本公司将遵守相关法律法规的要求，在跨境传输前依法开展数据出境安全评估，并尽最大的可能对个人信息进行匿名化处理或去标识化处理，以保护用户的个人信息安全。"]
      }]
    }]
  }, {
    title: "七、用户权限",
    items: [{
      itemList: [{
        listTitle: "按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，本公司保障用户对自己的个人信息行使以下权利："
      }]
    }, {
      itemTitle: "1. 访问用户的个人信息 ",
      itemList: [{
        listTitle: "用户有权访问用户的个人信息，法律法规规定的例外情况除外。如果用户想行使数据访问权，可以通过以下方式自行访问：",
        listItems: ["· 会员注册信息及身份验证信息——如果用户希望访问用户的会员注册信息中的个人资料信息，身份验证信息，登录密码等，用户可以访问本公司官网，APP和小程序个人中心模块执行此类访问操作。搜索信息——用户可以在公司官网，APP和小程序中访问搜索历史记录。", "· 搜索信息——用户可以在本公司官网，APP和小程序中访问搜索历史记录。", "· 订单记录——用户可以在本公司官网，APP和小程序中订单详情模块访问订单记录。", "如果用户无法通过上述链接访问这些个人信息，用户可联系本公司进行提供，联系方式参见本政策第十一条。 本公司将在十五个工作日内回复用户的访问请求。", "对于用户在使用本公司的产品或服务过程中产生的其他个人信息，只要本公司不需要过多投入，本公司会向用户提供。如果用户想行使数据访问权，可联系本公司进行提供，联系方式参见本政策第十一条。"]
      }]
    }, {
      itemTitle: "2. 更正用户的个人信息",
      itemList: [{
        listTitle: "当用户发现本公司处理的关于用户的个人信息有错误时，用户有权要求本公司进行更正。用户可以通过以下方式更正个人信息：",
        listItems: ["· 会员注册信息及身份验证信息——如果用户希望更改用户的会员注册信息中的个人资料信息、身份验证信息、登录密码等，用户可以访问本公司官网，野兽派APP和小程序个人中心模块执行此类操作。", "· 搜索信息——用户可以在公司官网，APP和小程序中删除搜索历史记录。", "· 订单记录——用户可以在公司官网，APP和小程序中订单详情模块删除订单记录。", "如果用户无法通过上述方法更正这些个人信息，用户可以随时联系本公司进行更正，联系方式参见本政策第十一条本公司将在十五个工作日内回复用户的更正请求。"]
      }]
    }, {
      itemTitle: "3. 删除用户的个人信息",
      itemList: [{
        listTitle: "在以下情形中，用户可以向本公司提出删除个人信息的请求："
      }, {
        listTitle: "（1）如果本公司处理个人信息的行为违反法律法规；"
      }, {
        listTitle: "（2）如果本公司收集、使用用户的个人信息，却未征得用户的同意；"
      }, {
        listTitle: "（3）如果本公司处理个人信息的行为违反了与用户的约定；"
      }, {
        listTitle: "（4）如果用户不再使用本公司的产品或服务，或用户注销了账号；"
      }, {
        listTitle: "（5）如果本公司不再为用户提供产品或服务。"
      }, {
        listTitle: "若本公司决定响应用户的删除请求，本公司还将同时通知从本公司获得用户的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体非通过本公司而独立获得用户的单独授权。",
        listItems: ["当用户从本公司的服务中删除信息后，本公司可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。"]
      }]
    }, {
      itemTitle: "4. 改变用户授权同意的范围",
      itemList: [{
        listTitle: "每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，用户可以联系本公司随时给予或收回授权同意，联系方式参见本政策第十一条。",
        listItems: ["当用户收回同意后，本公司将不再处理相应的个人信息。但用户收回同意的决定，不会影响此前基于用户的授权而开展的个人信息处理。", "如果用户不想接受本公司给用户发送的商业广告，用户随时可通过以下方式取消：", "· 野兽派APP推送/弹窗消息——用户可以在手机上设置不接受此类推送/弹窗消息;", "· 短信——用户可以在短信中选择退订;", "· 微信服务号推送消息——用户可以取消关注服务号。"]
      }]
    }, {
      itemTitle: "5. 个人信息主体注销账户",
      itemList: [{
        listTitle: "用户可以在野兽派APP及小程序的个人中心模块随时注销此前注册的账户。",
        listItems: ["在注销账户之后，本公司将停止为用户提供产品或服务，并依据用户的要求，删除用户的个人信息，法律法规另有规定的除外。"]
      }]
    }, {
      itemTitle: "6. 个人信息主体获取个人信息副本",
      itemList: [{
        listTitle: "用户有权联系本公司获取用户的个人信息副本，联系方式参见本政策第十一条。",
        listItems: ["在技术可行的前提下，如数据接口已匹配，本公司还可按用户的要求，直接将用户的个人信息副本传输给用户指定的第三方。"]
      }]
    }, (0, _defineProperty3.default)({
      itemList: "7. 约束信息系统自动决策"
    }, "itemList", [{
      listTitle: "在某些业务功能中，本公司可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响用户的合法权益，用户有权要求本公司作出解释，本公司也将提供适当的救济方式。"
    }]), {
      itemTitle: "8. 响应用户的上述请求",
      itemList: [{
        listTitle: "为保障安全，用户可能需要提供书面请求，或以其他方式证明用户的身份。本公司可能会先要求用户验证自己的身份，然后再处理用户的请求。",
        listItems: ["本公司将在十五个工作日内作出答复。如用户不满意，还可以联系本公司进行投诉，联系方式参见本政策第十一条。", "对于用户合理的请求，本公司原则上不收取费用，但对多次重复、超出合理限度的请求，本公司将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例等）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，本公司可能会予以拒绝。", "在以下情形中，本公司将无法响应用户的请求："]
      }, {
        listTitle: "（1）与个人信息控制者履行法律法规规定的义务相关的；"
      }, {
        listTitle: "（2）与国家安全、国防安全直接相关的；"
      }, {
        listTitle: "（3）与公共安全、公共卫生、重大公共利益直接相关的；"
      }, {
        listTitle: "（4）与刑事侦查、起诉、审判和执行判决等直接相关的；"
      }, {
        listTitle: "（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；"
      }, {
        listTitle: "（6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"
      }, {
        listTitle: "（7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；"
      }, {
        listTitle: "（8）涉及商业秘密的。"
      }]
    }]
  }, {
    title: "八、如何处理未成年人的个人信息",
    items: [{
      itemList: [{
        listTitle: "本公司的产品、网站和服务主要面向成年人。如果没有父母或监护人的同意，未成年人不应创建自己的个人信息主体账户。 ",
        listItems: ["未成年人如创建自己的个人信息主体账户并成为本公司会员，请在征得父母或监护人同意之后，由父母或监护人代为注册。如果未成年人未经父母或监护人同意，但隐瞒未成年人身份注册成为本公司会员的，本公司将视其为成年人会员。如果该未成年人或其父母、监护人在之后要求本公司停止向该会员账号提供服务的，本公司将在核实相关情况后立即取消该会员资格、停止提供会员服务，并按照国家有关法律法规的规定删除该会员账号以及相关个人信息。", "对于经父母或监护人同意而收集未成年个人信息的情况，本公司只会在受到法律允许、父母或监护人同意或者保护未成年所必要的情况下使用或公开披露此信息。", "如果本公司发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。"]
      }]
    }]
  }, {
    title: "九、当用户向本公司提供第三方数据",
    items: [{
      itemList: [{
        listTitle: "在用户接受本公司所提供的功能和服务中，如果用户主动向本公司提供了第三方的个人数据、个人信息（例如购买本公司产品，下单赠送第三方时），用户需要确认用户处理第三方个人数据或个人信息的方式、目的、范围，应确保已于向本公司提供前已向前述信息主体的第三方进行了告知，且用户已经明确获得了第三方的正面同意。"
      }]
    }]
  }, {
    title: "十、本政策如何更新",
    items: [{
      itemList: [{
        listTitle: "本公司的个人信息保护政策可能变更。",
        listItems: ["未经用户明确同意，本公司不会削减用户按照本政策所应享有的权利。本公司会在本页面上发布对本政策所做的任何变更。", "对于重大变更，本公司还会提供更为显著的通知（包括对于某些服务，本公司会通过电子邮件发送通知，说明个人信息保护政策的具体变更内容）。", "本政策所指的重大变更包括但不限于："]
      }, {
        listTitle: "1、本公司的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；"
      }, {
        listTitle: "2、本公司在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；"
      }, {
        listTitle: "3、个人信息共享、转让或公开披露的主要对象发生变化；"
      }, {
        listTitle: "4、用户参与个人信息处理方面的权利及其行使方式发生重大变化；"
      }, {
        listTitle: "5、本公司负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；"
      }, {
        listTitle: "6、个人信息安全影响评估报告表明存在高风险时。"
      }, {
        listTitle: "另外，本政策如有更新，本公司还会将本政策的旧版本存档，供用户查阅。"
      }]
    }]
  }, {
    title: "十一、如何联系本公司",
    items: [{
      itemList: [{
        listTitle: "如果用户对本政策有任何疑问、意见或建议，用户可以在野兽派官网(www.thebeastshop.com)，野兽派APP和小程序联系人工客服，与个人信息保护相关负责人员获得联络。",
        listItems: ["一般情况下，本公司将在十五个工作日内回复。"]
      }]
    }]
  }]
};

exports.default = ruleData;

/***/ }),

/***/ 1915:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "desc-box"
  }, [_c('div', {
    staticClass: "text-box"
  }, _vm._l((_vm.data.desc1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "text-item"
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, _vm._l((_vm.data.desc2), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "text-item"
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "stress-box"
  }, [_c('div', {
    staticClass: "stress-title"
  }, [_vm._v(_vm._s(_vm.data.stress.title))]), _vm._v(" "), _vm._l((_vm.data.stress.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "stress-item"
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, _vm._l((_vm.data.desc3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "text-item"
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, _vm._l((_vm.data.contents), function(content, cIndex) {
    return _c('div', {
      key: cIndex,
      staticClass: "content-item-box"
    }, [(content.title) ? _c('div', {
      staticClass: "content-title"
    }, [_vm._v("\n        " + _vm._s(content.title) + "\n      ")]) : _vm._e(), _vm._v(" "), (content.stress) ? _c('div', {
      staticClass: "content-stress"
    }, [_vm._v("\n        " + _vm._s(content.stress) + "\n      ")]) : _vm._e(), _vm._v(" "), (content.items && content.items.length) ? _c('div', {
      staticClass: "content-item-box"
    }, _vm._l((content.items), function(item, iIndex) {
      return _c('div', {
        key: iIndex,
        staticClass: "content-item"
      }, [(item.itemTitle) ? _c('div', {
        staticClass: "item-title"
      }, [_vm._v("\n            " + _vm._s(item.itemTitle) + "\n          ")]) : _vm._e(), _vm._v(" "), (item.itemList && item.itemList.length) ? _c('div', {
        staticClass: "item-list-box"
      }, _vm._l((item.itemList), function(list, lIndex) {
        return _c('div', {
          key: lIndex,
          staticClass: "item-list"
        }, [(list.listTitle) ? _c('div', {
          staticClass: "list-title"
        }, [_vm._v("\n                " + _vm._s(list.listTitle) + "\n              ")]) : _vm._e(), _vm._v(" "), (list.listTable) ? _c('div', {
          staticClass: "list-image"
        }, [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (list.listItems && list.listItems.length) ? _c('div', {
          staticClass: "list-item-box"
        }, _vm._l((list.listItems), function(listItem, liIndex) {
          return _c('div', {
            key: liIndex,
            staticClass: "list-item"
          }, [_vm._v("\n                  " + _vm._s(listItem) + "\n                ")])
        }), 0) : _vm._e()])
      }), 0) : _vm._e()])
    }), 0) : _vm._e()])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("第三方收集的信息类型")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("场景用途描述")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("第三方类型")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("野兽派官网")]), _vm._v(" "), _c('td', [_vm._v("网络状态、操作系统信息、用户所在城市、浏览器信息")]), _vm._v(" "), _c('td', [_vm._v("数据分析、数据统计")]), _vm._v(" "), _c('td', [_vm._v("TalkingData")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      网络状态、GPS定位信息、设备信息（IDFA、操作系统、设备型号、设备制造商、系统版本、AndroidID、IMEI、MAC地址）\n                    ")]), _vm._v(" "), _c('td', [_vm._v("数据分析、数据统计")]), _vm._v(" "), _c('td', [_vm._v("神策数据SDK")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "14"
    }
  }, [_vm._v("野兽派APP")]), _vm._v(" "), _c('td', [_vm._v("\n                      设备Mac地址、唯一设备识别码(IMEl/androidID/IDFA/OPENUDID/GUID、SIM卡IMSI信息)\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      消息推送，及提供统计分析服务,并通过地理位置校准报表数据准确性,提供基础反作弊能力\n                    ")]), _vm._v(" "), _c('td', [_vm._v("友盟+SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)：用于识别用户的设备类型、设备型号、系统版本等，确保消息准确下发；\n                      设备标识符（IMEI、IDFA、Android ID、GAID、 MAC、OAID、VAID、AAID、IMSI、MEID、UAID、硬件序列号信息、ICCID、SIM信息）：用于识别唯一用户，保证推送的精准送达及推送信息的准确统计；\n                      网络信息(IP 地址、WiFi 信息、基站信息、DNS地址、DHCP地址、SSID、BSSID)与位置信息（经纬度）：用于优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性，同时实现区域推送功能；\n                      应用列表信息(应用崩溃信息、通知开关状态、APP 应用列表及活跃状态、APP 应用页面信息、APP 功能事件相关信息)：当一个设备有多个 APP 的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户节省电省流量的目的。\n                      数据处理方式：通过去标识化、加密传输及其他安全方式\n                      关于自启动：为保障您可以正常接收推送消息，本应用使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，避免遗漏重要消息通知遗漏。\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      为 APP 用户提供信息推送服务\n                    ")]), _vm._v(" "), _c('td', [_vm._v("极光推送SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      应用信息、设备信息（设备的硬件信息、系统基本信息和系统设置）\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      推送消息\n                    ")]), _vm._v(" "), _c('td', [_vm._v("华为 HMS SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      应用匿名标识 (AAID)，应用 Token\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      推送消息\n                    ")]), _vm._v(" "), _c('td', [_vm._v("荣耀推送 SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      应用基本信息（MCS 应用包名、应用版本号、OPUSH SDK版本号），应用内设备标识符（RegistraterID、appKey、appSecret）\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      推送消息\n                    ")]), _vm._v(" "), _c('td', [_vm._v("OPPO 推送 SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      推送消息\n                    ")]), _vm._v(" "), _c('td', [_vm._v("vivo 推送 SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      设备相关信息（手机品牌、手机型号、系统版本、系统语言，以及设备标识符PUSHID）和应用信息、推送状态\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      推送消息\n                    ")]), _vm._v(" "), _c('td', [_vm._v("魅族推送 SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("设备唯一标识码、网络状态、网络制式、设备序列号")]), _vm._v(" "), _c('td', [_vm._v("消息推送")]), _vm._v(" "), _c('td', [_vm._v("小米推送SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      位置信息(可能包括GNSS信息、WIFI地址及信号强度信息、基站ID数据信息、传感器信息、手机信号强度信息)、WiFi状态、设备信息(包括AndroidID、操作系统版本、设备品牌及型号、设备配置、应用信息(应用名))，详细隐私政策链接：https://lbsyun.baidu.com/index.php?title=openprivacy\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      优化定位，追踪、排查、诊断、统计服务中的各类问题，保障产品和服务正常运行\n                    ")]), _vm._v(" "), _c('td', [_vm._v("百度定位SDK 开发者名称：北京百度网讯科技有限公司")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("网络状态、操作系统信息、用户所在城市、设备识别码")]), _vm._v(" "), _c('td', [_vm._v("数据分析、数据统计")]), _vm._v(" "), _c('td', [_vm._v("TalkingData")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      网络状态、GPS定位信息、设备信息（IDFA、操作系统、设备型号、设备制造商、系统版本、AndroidID、IMEI、MAC地址）\n                    ")]), _vm._v(" "), _c('td', [_vm._v("数据分析、数据统计")]), _vm._v(" "), _c('td', [_vm._v("神策数据SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      设备及系统信息（包括操作系统类型、系统版本、App包名、App版本、设备类型、设备厂商、设备型号）、网络身份标识信息（IP地址）\n                    ")]), _vm._v(" "), _c('td', [_vm._v("售后客服")]), _vm._v(" "), _c('td', [_vm._v("智齿客服SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      设备标识符（Android如IMEI、Android ID、IMSI，iOS如IDFV）、MAC地址、IP地址、位置信息\n                    ")]), _vm._v(" "), _c('td', [_vm._v("为用户提供QQ三方登录功能，帮助用户分享内容至QQ")]), _vm._v(" "), _c('td', [_vm._v("QQ互联（腾讯开放平台）SDK")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      设备标识符（Android如IMEI、Android ID、IMSI，iOS如IDFV）、MAC地址、IP地址、位置信息\n                    ")]), _vm._v(" "), _c('td', [_vm._v("为用户提供微信三方登录功能，帮助用户分享内容至微信，帮助用户在应用内使用微信支付")]), _vm._v(" "), _c('td', [_vm._v("微信Open（微信开放平台）SDK")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("野兽派小程序")]), _vm._v(" "), _c('td', [_vm._v("定位信息、网络状态")]), _vm._v(" "), _c('td', [_vm._v("地址导航、门店定位")]), _vm._v(" "), _c('td', [_vm._v("腾讯地图")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("网络状态、操作系统信息、用户所在城市、设备识别码")]), _vm._v(" "), _c('td', [_vm._v("数据分析、数据统计")]), _vm._v(" "), _c('td', [_vm._v("TalkingData")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                      网络状态、GPS定位信息、设备信息（IDFA、操作系统、设备型号、设备制造商、系统版本、AndroidID、IMEI、MAC地址）\n                    ")]), _vm._v(" "), _c('td', [_vm._v("数据分析、数据统计")]), _vm._v(" "), _c('td', [_vm._v("神策数据SDK")])])])
}]}

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _events = __webpack_require__(52);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  function install(Vue) {
    var on = function on() {
      var _bevent$$on;

      for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      (_bevent$$on = _events2.default.$on).call.apply(_bevent$$on, [_events2.default].concat(arg));
    };

    var emit = function emit() {
      var _bevent$$emit;

      for (var _len2 = arguments.length, arg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        arg[_key2] = arguments[_key2];
      }

      (_bevent$$emit = _events2.default.$emit).call.apply(_bevent$$emit, [_events2.default].concat(arg));
    };
    Vue.mixin({
      created: function created() {
        this._on = on;
        this._emit = emit;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    _vue2.default.use(install);
  }
})();

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _toast = __webpack_require__(46);

var _toast2 = _interopRequireDefault(_toast);

var _browser = __webpack_require__(1);

var _bridge = __webpack_require__(7);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;
var _resolve = void 0;
var _reject = void 0;

(function () {
  function install(Vue) {
    var Toast = Vue.extend(_toast2.default);
    var toast = function toast(content) {
      if ((0, _browser.app)()) {
        return _bridge2.default.toast(content);
      }
      if (!content) {
        throw new Error('Plugins $toast args must be \'String\' ');
      }
      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.show = true;
      $vm.mask = false;
      $vm.toast = true;
      $vm.autoClose = true;
      $vm.content = content;
      $vm.$on('toast-hide', function (msg) {
        _resolve();
      });
      return new _promise2.default(function (resolve) {
        _resolve = resolve;
      });
    };

    var alert = function alert(option) {
      if (!option) {
        throw new Error('Plugins $alert args must be \'String\' or \'Object\'');
      }
      if ((0, _browser.app)()) {
        return _bridge2.default.alert(option);
      }

      // if (!/^[\u4e00-\u9fa5_a-zA-Z0-9@()!：；:,。"'\[\]]+$/g.test(option)) {
      //   throw new Error(`Plugins $alert args must be 'String' or 'Object'`);
      // }

      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.show = true;
      $vm.maskTouchHide = true;
      $vm.alert = true;
      if ((typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object') {
        option.buttonText && ($vm.primary = option.buttonText);
        $vm.title = option.title;
        $vm.content = option.content;
        $vm.buttonEmphasize = option.buttonEmphasize;
      } else {
        $vm.content = option;
      }
      $vm.$on('alert-hide', function (msg) {
        _resolve();
      });
      return new _promise2.default(function (resolve) {
        _resolve = resolve;
      });
    };

    var confirm = function confirm(option) {
      if (!option) {
        throw new Error('Plugins $confirm args must be \'String\' or \'Object\'');
      }
      if ((0, _browser.app)() && (0, _browser.ios)()) {
        return _bridge2.default.confirm(option);
      }
      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.show = true;
      $vm.confirm = true;
      if ((typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object') {
        option.primaryButtonText && ($vm.primary = option.primaryButtonText);
        option.secondaryButtonText && ($vm.secondary = option.secondaryButtonText);
        $vm.content = option.content;
        $vm.title = option.title;
        $vm.primaryButtonEmphasize = option.primaryButtonEmphasize;
        $vm.secondaryButtonEmphasize = option.secondaryButtonEmphasize;
      } else {
        $vm.title = option;
      }
      $vm.$on('confirm-ensure', function () {
        _resolve();
      });
      $vm.$on('confirm-cancel', function () {
        _reject();
      });
      return new _promise2.default(function (resolve, reject) {
        _resolve = resolve;
        _reject = reject;
      });
    };
    // if (!Vue.$beast) {
    //   Vue.$beast = {}
    // }

    // Vue.$beast.toast = toast
    // Vue.$beast.alert = alert
    // Vue.$beast.confirm = confirm

    Vue.mixin({
      created: function created() {
        this.$toast = toast;
        this.$alert = alert;
        this.$confirm = confirm;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _loading = __webpack_require__(41);

var _loading2 = _interopRequireDefault(_loading);

var _browser = __webpack_require__(1);

var _bridge = __webpack_require__(7);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;
// let _resolve
// let _reject

(function () {
  function install(Vue) {
    var Loading = Vue.extend(_loading2.default);
    var showLoading = function showLoading(flag) {
      if ((0, _browser.app)()) {
        _bridge2.default.showLoading();
        return;
      }
      if (!$vm) {
        $vm = new Loading({
          el: document.createElement('div')
          // propsData: {
          //   mshow: true
          // }
        });
        document.body.appendChild($vm.$el);
      }
      $vm.white = flag ? true : false;
      $vm.mshow = true;
      $vm.$on('loading-hide', function (msg) {
        $vm.mshow = false;
      });
      // return new Promise((resolve) => {
      //   _resolve = resolve
      // })
    };

    var hideLoading = function hideLoading() {
      if ((0, _browser.app)()) {
        return _bridge2.default.hideLoading();
      }
      $vm && $vm.$emit('loading-hide');
    };

    Vue.mixin({
      created: function created() {
        this.$showLoading = showLoading;
        this.$hideLoading = hideLoading;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _browser = __webpack_require__(1);

var _bridge = __webpack_require__(7);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  function install(Vue) {
    var title = function title(_title) {
      var _this = this;

      if ((0, _browser.app)()) {
        _bridge2.default.setTitle(_title);
      }
      if ((typeof _title === 'undefined' ? 'undefined' : (0, _typeof3.default)(_title)) === 'object') {
        return;
      }
      document.title = _title;

      this.$nextTick(function () {
        _this._emit && _this._emit('change-title', _title);
      });
    };
    Vue.mixin({
      created: function created() {
        this.$setTitle = title;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(16);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Masks: _index2.default,
    MaxZIndex: _index4.default
  },
  props: {
    mshow: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'beast-mask'
    },
    // maskStyle: {
    //   type: String,
    //   default: 'beast__mask'
    // },
    dialogTransition: {
      type: String,
      default: 'beast-dialog'
    },
    dialogStyle: {
      type: String,
      default: 'beast__dialog'
    },
    mask: {
      type: Boolean,
      default: true
    },
    maskTouchHide: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: true
    },
    maskOpacity: {
      // type: Number,
      default: 0.4
    },
    maskBackground: {
      default: '#000000'
    },
    maskClass: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  created: function created() {
    if (typeof this.mshow !== 'undefined') {
      this.currentValue = this.mshow;
    }
  },
  data: function data() {
    return {
      currentValue: false
    };
  },


  computed: {
    mOpacity: function mOpacity() {
      return this.mask ? parseFloat(this.maskOpacity) : 0;
    },
    mBackground: function mBackground() {
      return this.mask ? this.maskBackground : '#000000';
    }
  },

  watch: {
    mshow: function mshow(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      val || this.$emit('mask-hide');
    }
  },
  methods: {
    onTouchMove: function onTouchMove(event) {
      !this.scroll && event.preventDefault();
    },
    maskHide: function maskHide() {
      this.mask && this.maskTouchHide && (this.currentValue = false);
    }
  }
};

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STYLES = {
  height: '100%',
  width: '100%',
  position: 'fixed',
  zIndex: 1000,
  top: 0,
  left: 0,
  opacity: 0.4,
  background: '#000000'
}; //
//
//
//

var handler = function handler(e) {
  e.preventDefault();
  // e.stopPropagation()
};

exports.default = {
  name: 'mask',
  props: {
    mshow: Boolean,
    mopacity: Number,
    zIndex: Number,
    mbackground: String,
    mclass: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      maskStyles: '',
      isShow: false
    };
  },
  created: function created() {
    this.showChange();
  },

  watch: {
    'zIndex': function zIndex(val) {
      this.showChange();
    },
    'mshow': function mshow(val) {
      // if(!val) {
      //   return
      // }
      this.showChange();
    }
  },
  methods: {
    maskTap: function maskTap() {
      this.$emit('maskTap');
    },
    showChange: function showChange() {
      // if(this.mshow){
      //   this.$el && this.$el.addEventListener('touchmove', handler, false)
      // }else{
      //   this.$el && this.$el.removeEventListener('touchmove', handler, false)
      // }
      this.mbackground !== undefined && (DEFAULT_STYLES.background = this.mbackground);
      this.zIndex !== undefined && (DEFAULT_STYLES.zIndex = this.zIndex);
      this.mopacity !== undefined && (DEFAULT_STYLES.opacity = this.mopacity);
      this.maskStyles = _utils2.default.setStyle(DEFAULT_STYLES).join(';');
      this.isShow = this.mshow;
    }
  }
};

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  setStyle: function setStyle(opts) {
    var styles = [];
    (0, _keys2.default)(opts).forEach(function (style) {
      var origin = opts[style];
      styles.push(style + ':' + origin);
    });
    return styles;
  }
};

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "beast-mask",
    class: _vm.mclass,
    style: (_vm.maskStyles),
    on: {
      "click": _vm.maskTap
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(38);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  props: {
    show: {
      type: Boolean,
      default: false
    },
    relative: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      ownZIndex: _index2.default.getZIndex()
    };
  },

  watch: {
    'show': function show(val) {
      val && (this.ownZIndex = _index2.default.getZIndex());
    }
  }
}; //
//
//
//
//
//

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base_index = 50000;
module.exports = {
  getZIndex: function getZIndex() {
    return base_index++;
  }
};

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j_max_index",
    class: {
      'relative-z-index': _vm.relative
    },
    style: ({
      zIndex: _vm.ownZIndex
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _axiosM = __webpack_require__(66);

var _axiosM2 = _interopRequireDefault(_axiosM);

var _browser = __webpack_require__(1);

var _b2a = __webpack_require__(22);

var _sa = __webpack_require__(17);

var _sa2 = _interopRequireDefault(_sa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import cookie from 'js-cookie'
exports.default = function (options) {
  if (!(0, _browser.app)()) {
    var getUTMProp = _sa2.default.getUTMProp,
        getAnonymousID = _sa2.default.getAnonymousID,
        current_page_id = _sa2.default.current_page_id,
        current_page_name = _sa2.default.current_page_name,
        current_page_type = _sa2.default.current_page_type;


    var utmData = {};
    var cache_utm_source = null;

    try {
      utmData = getUTMProp();
      cache_utm_source = window.localStorage.getItem('the_utm_source') || null;
    } catch (err) {}

    utmData['theLatestUtmSource'] = cache_utm_source ? JSON.parse(cache_utm_source).value : '';
    // const userId = cookie.get('_b_m_c')
    var sensors = (0, _extends3.default)({
      // userId: userId || '',
      anonymousId: getAnonymousID(),
      currentPageType: current_page_type,
      currentPageName: current_page_name,
      currentPageId: current_page_id
    }, utmData);
    options.headers = {
      'TBS-Sensors': (0, _b2a.btoa)((0, _stringify2.default)(sensors))
    };
  }
  if ((0, _browser.android)()) {
    var url = options.url;
    options.url = url.replace('/app', 'app'); //兼容安卓
  }
  return (0, _axiosM2.default)(options);
};

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('max-z-index', {
    attrs: {
      "show": _vm.currentValue
    }
  }, [_c('div', {
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('masks', {
    attrs: {
      "mshow": _vm.currentValue,
      "mopacity": _vm.mOpacity,
      "mbackground": _vm.mBackground,
      "mclass": _vm.maskClass
    },
    on: {
      "maskTap": _vm.maskHide
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.dialogStyle,
    staticStyle: {
      "z-index": "1001!important"
    }
  }, [_vm._t("default")], 2)])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(42)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(44),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(10);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'loading',
  components: {
    dialogs: _index2.default
  },
  props: ['white'],
  data: function data() {
    return {
      mopacity: 0,
      mshow: false
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dialogs', {
    attrs: {
      "mshow": _vm.mshow,
      "scroll": false,
      "mask": false
    }
  }, [_c('div', {
    staticClass: "beast-loading__icon",
    class: {
      'icon_white': _vm.white
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(49),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 47:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _dialog = __webpack_require__(10);

var _dialog2 = _interopRequireDefault(_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _confirm_state = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _data = {
  show: false,
  time: 2000,
  autoClose: false,
  toast: false,
  alert: false,
  confirm: false,
  primary: "确定",
  secondary: "取消",
  title: '',
  content: '',
  myClass: 'beast__toast'
};
exports.default = {
  components: {
    BDialog: _dialog2.default
  },
  data: function data() {
    return JSON.parse((0, _stringify2.default)(_data));
  },

  watch: {
    content: function content(val) {
      if (val) {
        this.show = true;
      }
    },
    toast: function toast(val) {
      if (val) {
        this.myClass = 'beast__toast';
      }
    },
    alert: function alert(val) {
      if (val) {
        this.myClass = 'beast__alert';
      }
    },
    confirm: function confirm(val) {
      if (val) {
        this.myClass = 'beast__confirm';
      }
    },
    show: function show(val) {
      var _this = this;

      this.autoClose && clearTimeout(this.timeout);
      if (val) {
        this.autoClose && (this.timeout = setTimeout(function () {
          _this.show = false;
        }, this.time));
      } else {
        this.toast && this.$emit('toast-hide');
        this.alert && this.$emit('alert-hide');
        if (this.confirm) {
          _confirm_state ? this.$emit('confirm-ensure') : this.$emit('confirm-cancel');
        }

        for (var _key in _data) {
          this[_key] = _data[_key];
        }
      }
    }
  },
  methods: {
    close: function close(event) {
      this.show = false;
    },
    cancel: function cancel(event) {
      _confirm_state = false;
      this.show = false;
    },
    ensure: function ensure(event) {
      _confirm_state = true;
      this.show = false;
    }
  }
};

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "mask": false,
      "mshow": _vm.show
    }
  }, [_c('div', {
    staticClass: "toast-wrap"
  }, [_c('div', {
    class: _vm.myClass
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]), _vm._v(" "), _c('div', {
    class: {
      lighter: _vm.title
    }
  }, [_vm._v("\n            " + _vm._s(_vm.content) + "\n          ")])])]), _vm._v(" "), (_vm.alert) ? _c('div', {
    staticClass: "alert",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        " + _vm._s(_vm.primary) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.confirm) ? _c('div', {
    staticClass: "confirm"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.secondary))]), _vm._v(" "), _c('div', {
    staticClass: "ensure",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.primary))])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _toast = __webpack_require__(26);

var _toast2 = _interopRequireDefault(_toast);

var _loading = __webpack_require__(27);

var _loading2 = _interopRequireDefault(_loading);

var _events = __webpack_require__(25);

var _events2 = _interopRequireDefault(_events);

var _setTitle = __webpack_require__(29);

var _setTitle2 = _interopRequireDefault(_setTitle);

var _sa = __webpack_require__(17);

var _sa2 = _interopRequireDefault(_sa);

var _browser = __webpack_require__(1);

var _queryString = __webpack_require__(11);

var _queryString2 = _interopRequireDefault(_queryString);

var _axiosMock = __webpack_require__(4);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _vconsole = __webpack_require__(72);

var _vconsole2 = _interopRequireDefault(_vconsole);

var _b2a = __webpack_require__(22);

var _jsCookie = __webpack_require__(61);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';
var md5 = __webpack_require__(53);

var isDev = "production" == 'development';
var UA = typeof navigator !== 'undefined' && navigator ? navigator.userAgent || '' : '';
var appDebug = !!~UA.indexOf('BEAST_DEBUG');
var _search = _queryString2.default.parse(window.location.search);
var webDebug = 'beast_debug' in _search;
if (appDebug || webDebug) {
  new _vconsole2.default();
}
var utm_source = _search.utm_source || '';
var _cache_utm_source = window.localStorage.getItem('the_utm_source');
var cache_utm_source = _cache_utm_source ? JSON.parse(_cache_utm_source) : '';
var distinctID = _search.distinctID;
var userId = window.sessionStorage.getItem('_b_m');
var miniMember = _search._mini_m;

if (miniMember) {
  miniMember = JSON.parse(decodeURIComponent(miniMember));
}

if (utm_source) {
  updateUtmParam(utm_source);
  _sa2.default.thelatest_utm_source = utm_source;
} else if (!utm_source && cache_utm_source) {
  if (isMoreThanSevenDays(cache_utm_source.createTime)) {
    window.localStorage.removeItem('the_utm_source');
    _sa2.default.thelatest_utm_source = '';
  } else {
    _sa2.default.thelatest_utm_source = cache_utm_source.value;
  }
}

if (distinctID) {
  if (miniMember && (typeof miniMember === 'undefined' ? 'undefined' : (0, _typeof3.default)(miniMember)) === 'object') {
    _sa2.default.login(md5.hexMD5(miniMember.mobile));
  }
  _sa2.default.is_login = true;
  _sa2.default.platform_type = '微信小程序';
  _sa2.default.changeIdentify(distinctID, true);
} else if (userId) {
  userId = JSON.parse(userId);
  _sa2.default.is_login = true;
  _sa2.default.platform_type = 'WAP';
  _sa2.default.login(md5.hexMD5(userId.mobile));
}

_sa2.default.init();

window.sa = _sa2.default;

function isMoreThanSevenDays(time) {
  var curTime = new Date().getTime();
  return curTime - time > 7 * 24 * 3600 * 1000;
}

function updateUtmParam(value) {
  window.localStorage.setItem('the_utm_source', (0, _stringify2.default)({
    value: value,
    createTime: new Date().getTime()
  }));
}

_vue2.default.use(_toast2.default);
_vue2.default.use(_events2.default);
_vue2.default.use(_loading2.default);
_vue2.default.use(_setTitle2.default);
_vue2.default.config.productionTip = false;

exports.Page = function (page, options) {
  if (options.pageType) {
    _sa2.default.setCurrentPage(options.pageType);
  }
  _sa2.default._autoQuick();
  var vm = new _vue2.default(options);
  return vm;
};

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = new _vue2.default({
  name: 'events'
});
exports.default = events;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance   */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_md5(s) {
  return rstr2hex(rstr_md5(str2rstr_utf8(s)));
}
function b64_md5(s) {
  return rstr2b64(rstr_md5(str2rstr_utf8(s)));
}
function any_md5(s, e) {
  return rstr2any(rstr_md5(str2rstr_utf8(s)), e);
}
function hex_hmac_md5(k, d) {
  return rstr2hex(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function b64_hmac_md5(k, d) {
  return rstr2b64(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function any_hmac_md5(k, d, e) {
  return rstr2any(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)), e);
}

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test() {
  return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of a raw string
 */
function rstr_md5(s) {
  return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
}

/*
 * Calculate the HMAC-MD5, of a key and some data (raw strings)
 */
function rstr_hmac_md5(key, data) {
  var bkey = rstr2binl(key);
  if (bkey.length > 16) bkey = binl_md5(bkey, key.length * 8);

  var ipad = Array(16),
      opad = Array(16);
  for (var i = 0; i < 16; i++) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
}

/*
 * Convert a raw string to a hex string
 */
function rstr2hex(input) {
  try {
    hexcase;
  } catch (e) {
    hexcase = 0;
  }
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var output = "";
  var x;
  for (var i = 0; i < input.length; i++) {
    x = input.charCodeAt(i);
    output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
  }
  return output;
}

/*
 * Convert a raw string to a base-64 string
 */
function rstr2b64(input) {
  try {
    b64pad;
  } catch (e) {
    b64pad = '';
  }
  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var output = "";
  var len = input.length;
  for (var i = 0; i < len; i += 3) {
    var triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 > input.length * 8) output += b64pad;else output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
    }
  }
  return output;
}

/*
 * Convert a raw string to an arbitrary string encoding
 */
function rstr2any(input, encoding) {
  var divisor = encoding.length;
  var i, j, q, x, quotient;

  /* Convert to an array of 16-bit big-endian values, forming the dividend */
  var dividend = Array(Math.ceil(input.length / 2));
  for (i = 0; i < dividend.length; i++) {
    dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
  }

  /*
   * Repeatedly perform a long division. The binary array forms the dividend,
   * the length of the encoding is the divisor. Once computed, the quotient
   * forms the dividend for the next step. All remainders are stored for later
   * use.
   */
  var full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
  var remainders = Array(full_length);
  for (j = 0; j < full_length; j++) {
    quotient = Array();
    x = 0;
    for (i = 0; i < dividend.length; i++) {
      x = (x << 16) + dividend[i];
      q = Math.floor(x / divisor);
      x -= q * divisor;
      if (quotient.length > 0 || q > 0) quotient[quotient.length] = q;
    }
    remainders[j] = x;
    dividend = quotient;
  }

  /* Convert the remainders to the output string */
  var output = "";
  for (i = remainders.length - 1; i >= 0; i--) {
    output += encoding.charAt(remainders[i]);
  }return output;
}

/*
 * Encode a string as utf-8.
 * For efficiency, this assumes the input is valid utf-16.
 */
function str2rstr_utf8(input) {
  var output = "";
  var i = -1;
  var x, y;

  while (++i < input.length) {
    /* Decode utf-16 surrogate pairs */
    x = input.charCodeAt(i);
    y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
    if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
      x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
      i++;
    }

    /* Encode output as utf-8 */
    if (x <= 0x7F) output += String.fromCharCode(x);else if (x <= 0x7FF) output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);else if (x <= 0xFFFF) output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);else if (x <= 0x1FFFFF) output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
  }
  return output;
}

/*
 * Encode a string as utf-16
 */
function str2rstr_utf16le(input) {
  var output = "";
  for (var i = 0; i < input.length; i++) {
    output += String.fromCharCode(input.charCodeAt(i) & 0xFF, input.charCodeAt(i) >>> 8 & 0xFF);
  }return output;
}

function str2rstr_utf16be(input) {
  var output = "";
  for (var i = 0; i < input.length; i++) {
    output += String.fromCharCode(input.charCodeAt(i) >>> 8 & 0xFF, input.charCodeAt(i) & 0xFF);
  }return output;
}

/*
 * Convert a raw string to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function rstr2binl(input) {
  var output = Array(input.length >> 2);
  for (var i = 0; i < output.length; i++) {
    output[i] = 0;
  }for (var i = 0; i < input.length * 8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
  }return output;
}

/*
 * Convert an array of little-endian words to a string
 */
function binl2rstr(input) {
  var output = "";
  for (var i = 0; i < input.length * 32; i += 8) {
    output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
  }return output;
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */
function binl_md5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;

  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);
}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}
function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xFFFF;
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
module.exports = {
  hexMD5: hex_md5
};

/***/ })

},[1910]);


// WEBPACK FOOTER //
// s/js/rule.fae9fe2096d64894fee9.js